import React, { useState, useEffect, useCallback } from 'react';

import {
  PageWrapper,
  Panel,
  Flex,
  Label,
  TextInput,
  Button,
  LoadingContainer,
  useNotification,
  LeftHalfLayout,
  Explainer
} from '@ubisend/pulse-components';

import { getNlpSettings, updateNlpSettings } from '../api/index';

const NlpDriverSettings = () => {
  const [settings, setSettings] = useState();
  const [saving, setSaving] = useState(false);

  const { showSuccess } = useNotification();

  const fetchSettings = useCallback(async () => {
    const { data } = await getNlpSettings();
    setSettings(data);
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const handleThresholdChange = event => {
    const value = event.target.value;
    setSettings(settings => ({ ...settings, threshold: value }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setSaving(true);
    try {
      await updateNlpSettings({ threshold: Number(settings.threshold) });
      showSuccess('NLP settings successfully updated.');
    } finally {
      setSaving(false);
    }
  };

  if (!settings) {
    return <LoadingContainer />;
  }

  return (
    <PageWrapper
      header="NLP Settings"
      subheader="Configure your NLP provider settings">
      <LeftHalfLayout>
        <Panel header="Context Threshold">
          <form onSubmit={handleSubmit}>
            <Flex col ySpace>
              <div>
                <Label htmlFor="threshold">Threshold</Label>
                <TextInput
                  id="threshold"
                  type="number"
                  value={settings.threshold ?? ''}
                  onChange={handleThresholdChange}
                  aria-label="nlp-threshold"
                />
                <Explainer mt>
                  Increasing the threshold raises the accuracy requirement for
                  accepting a match. Keep in mind that higher thresholds may
                  also result in slower response times from the chatbot.
                </Explainer>
              </div>
              <Flex right>
                <Button
                  variant="primary"
                  type="submit"
                  loading={saving}
                  disabled={saving}>
                  Save
                </Button>
              </Flex>
            </Flex>
          </form>
        </Panel>
      </LeftHalfLayout>
    </PageWrapper>
  );
};

export default NlpDriverSettings;
